"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Logo = function LogoComponent(_ref) {
  var href = _ref.href,
      title = _ref.title,
      image = _ref.image;

  if (href) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      className: "site-footer__logo-link",
      href: href,
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "site-footer__logo-link-helper_text"
    }, "Go to ".concat(href)), /*#__PURE__*/_react["default"].createElement("img", {
      className: "site-footer__logo-img",
      src: image,
      alt: title
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("img", {
    className: "site-footer__logo-img",
    src: image,
    alt: title
  });
};

Logo.defaultProps = {
  href: ''
};
Logo.propTypes = {
  href: _propTypes["default"].string,
  title: _propTypes["default"].string.isRequired,
  image: _propTypes["default"].string.isRequired
};
var _default = Logo;
exports["default"] = _default;